export default {
  templates: process.env.VUE_APP_MGNL_HOST + '/.rest/template-annotations/v1',
  pages: process.env.VUE_APP_MGNL_HOST + '/.rest/delivery/pages/v1',
  pages_preview: process.env.VUE_APP_MGNL_HOST + '/.rest/preview/pages/v1',
  nav: process.env.VUE_APP_MGNL_HOST + '/.rest/delivery/pagenav/v1',
  promotions: process.env.VUE_APP_MGNL_HOST + '/.rest/delivery/promotions'
};
